import script from "./banjixiaolikebiao.vue?vue&type=script&setup=true&lang=js"
export * from "./banjixiaolikebiao.vue?vue&type=script&setup=true&lang=js"

import "./banjixiaolikebiao.vue?vue&type=style&index=0&id=6cb649b4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cb649b4"]])

export default __exports__